import React from 'react';
import '../../styles/Membership.css';
import { FaChevronRight } from 'react-icons/fa';


export default function WorkingCommittee() {
  return (
    <div className='MemberShipContainer'>
        <div className='benefits-header-container' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/comittee_banner.jpg'})`, backgroundPosition: 'center'}}>
            <div className='benefits-header-content'>
                <div className='benefits-header-title'>
                    CANTO Working Committees
                </div>
                {/* <div className='benefits-header-btn'>
                    REGISTER NOW
                </div> */}
            </div>
        </div>
        
        <div style={{padding: '0 100px', margin: '60px 0'}}>
            <div className='MembershipCatTable'>
                <div className='MembershipCatTableTitle'>CANTO Working Committees</div>

                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>The Marketing & Communications Working Committee</div>
                    <div className='MembershipCatTableColumnSecond'>
                       This committee advises the Secretariat in finding ways to increase the visibility of CANTO among its
membership and the region and identifying the services they require.


                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>The Regulatory Working Committee</div>
                    <div className='MembershipCatTableColumnSecond'>
                        The role of the Regulatory and Emerging Technologies Committee (“the Committee”) is to provide the Board of Directors of CANTO with policy papers and guidelines on current and future regulatory and policy-related matters facing its members in the region.  The Committee shall also assist the Board in the adoption of any policies and regulatory decisions that support and benefit its members. 
                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>The Disaster Recovery Planning Working Committee</div>
                    <div className='MembershipCatTableColumnSecond'>
                        This committee will determine a strategy for advancing cooperation among members in disaster
preparedness by: collating and sharing information on the best practices adopted by members
across the region, maintaining a data base with contacts and developing a mutual assistance plan.

                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>The Financial Advisory Working Committee</div>
                    <div className='MembershipCatTableColumnSecond'>
                        This committee will advise the Board on matters affecting the financial operations of the
Association. Included under their purview are the following:
                        <ul>
                            <li>Reviewing annual financial reports, including the budget.</li>
                            <li>Identifying investment opportunities.</li>
                            <li>Ensuring maintenance of internal control procedures.</li>
                            <li>Recommending new sources of funding.</li>
                            <li>Recommend new sources of funding.</li>
                        </ul>
                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>Corporate Social Responsibility (CSR) Working Committee</div>
                    <div className='MembershipCatTableColumnSecond'>
                        This committee will be charged with identifying and addressing CSR issues and trends globally and
within the region; researching, identifying and promoting CSR best practices among the CANTO
membership; delivery of consultation on electronic waste disposal and highlighting existing and
identifying prospective CSR projects in region.

                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>Vendor/Supplier Working Committee</div>
                    <div className='MembershipCatTableColumnSecond'>
                        The committee will function as the other working committees of the Board with a Chair who will
report to the Board of Directors; a Vice Chair and members with the following Terms of Reference:
                        <ul>
                            <li>Provide a link of communication between the CANTO membership and the vendors/suppliers to share ideas and work together</li>
                            <li>Promote sharing of ideas, best practice and technology trends</li>
                            <li>Promote membership of the association.</li>
                            <li>Identify and recommend value add for the annual conference and trade exhibition</li>
                        </ul>
                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>Technology Trends Working Committee</div>
                    <div className='MembershipCatTableColumnSecond'>
                        The committee will function as the other working committees of the Board with a Chair who will
report to the Board of Directors; a Vice Chair and members with the following Terms of Reference:
                        <ul>
                            <li>To provide the Board with information on Technology Trends within the telecom industry and its impact on Caribbean Operators</li>
                            <li>To attract and strengthen relationships with the technical departments within the membership</li>
                            <li>To solicit input from members on possible initiatives/workshops emanating from the secretariat</li>
                            <li>To recommend topics of interest to members for consideration in the Annual Conference Schedule</li>
                            <li>Promote sharing of ideas, best practice and technology trends</li>
                        </ul>
                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>Women in ICT Working Committee</div>
                    <div className='MembershipCatTableColumnSecond'>
                        The women in ICT (WICT) committee of the Board of Directors will advocate for the advancement of women in the ICT sector while actively facilitating the engagement and ultimately the employment of a greater percentage of women in CANTO member countries.
                        <ul>
                            <li>Increase and support the participation of women in CANTO</li>
                            <li>Promote awareness of ICT sectors opportunities for girls and women to increase the number of those choosing careers in ICT</li>
                            <li>Liaise with other CANTO committees to actively support the mandate of the Women’s committee</li>
                            <li>Develop and execute an Annual Women in ICT forum</li>
                            <li>Partner with organisations that focus on the advancement of women</li>
                        </ul>
                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>Human Resources Working Committee</div>
                    <div className='MembershipCatTableColumnSecond'>
                        CANTO’s newly established HR Committee will focus on key human resources initiatives within the organization and the industry. More details, including the committee's mandate and objectives, will be available soon. Stay tuned!
                    </div>
                </div>
            </div>
        </div>

        <div style={{padding: '0 100px', marginBottom: '20px', fontSize: 24, fontWeight: 'bold'}}>Interested in joining a CANTO Committee, please fill out the form below</div>

        <div className='contact-form' style={{padding: '0 100px'}}>
            <div className='contact-form-title'>Name</div>
            <input className='contact-form-input' type='text' placeholder='Enter your Name...'/>

            <div className='contact-form-title'>Email</div>
            <input className='contact-form-input' type='text' placeholder='Enter your E-mail...'/>

            <div className='contact-form-title'>Phone/Mobile number</div>
            <input className='contact-form-input' type='text' placeholder='Enter your Phone Number...'/>

            <div className='contact-form-title'>Message</div>
            <textarea className='contact-form-input area' placeholder=''/>

            <div className='contact-form-btn-container'>
                <div className='contact-form-btn'>
                    Send 
                    <div className='contact-form-btn-icon'>
                        <FaChevronRight size={16} color='#fff'/>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
  )
}